module.exports = __webpack_public_path__ + "static/media/gradient_violet.edbc66bc.PNG";